module.exports = __webpack_public_path__ + "img/Character_Signora_Thumb.cfb8d5a9.png";